import React, { useCallback, useState } from "react";

import { Cached } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import debounce from "lodash.debounce";

import {
  SearchInput,
  CustomDatePicker,
  PassingCriteriaDialog,
  FilterDropDown,
} from "../../common";
import { resume_stages } from "../../static/data";

/* ============================================================================
<ResumeScreeningCandidatesTableHeader/>
============================================================================= */
const ResumeScreeningCandidatesTableHeader = ({
  actionLoading,
  tableDataLength,
  selectedRows,
  onReload,
  filters,
  onSearch,
  onReset,
  onFilterChange,
  onDeleteResumes,
  onRejectResumes,
  onRequestAssesment,
}) => {
  const [searchText, setSearchText] = useState("");

  const debounceFn = useCallback(debounce(onSearch, 500), []);

  const _handleSearchTextChange = (value) => {
    debounceFn(value);
    setSearchText(value);
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      p={2}
      justifyContent="space-between"
      alignItems="center"
      gap={1}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography fontSize="20px" fontWeight={700}>
          Candidate
        </Typography>
        <IconButton
          size="small"
          sx={{ border: "1px solid #B1B1B1" }}
          onClick={onReload}
        >
          <Cached sx={{ fontSize: 18, color: "#B1B1B1" }} />
        </IconButton>
      </Box>
      <Box
        flex={1}
        display="flex"
        width="100%"
        flexWrap="wrap"
        justifyContent="flex-end"
        alignItems="center"
        gap={1}
      >
        {selectedRows?.length && tableDataLength > 0 ? (
          <>
            {/* <Button
              variant="outlined"
              onClick={onDeleteResumes}
              disabled={actionLoading === "delete"}
              endIcon={
                actionLoading === "delete" && (
                  <CircularProgress size={18} sx={{ color: "#FF2D2D" }} />
                )
              }
              sx={{
                borderRadius: "40px",
                fontSize: "14px",
                px: { xs: 2, md: 4 },
                color: "#FF2D2D",
                borderColor: "#FF2D2D",
              }}
            >
              Delete
            </Button> */}
            {/* <Button
              variant="outlined"
              onClick={onRejectResumes}
              disabled={actionLoading === "reject"}
              endIcon={
                actionLoading === "reject" && (
                  <CircularProgress size={18} sx={{ color: "#848484" }} />
                )
              }
              sx={{
                borderRadius: "40px",
                fontSize: "14px",
                px: { xs: 2, md: 4 },
                color: "#848484",
                borderColor: "#848484",
              }}
            >
              Reject
            </Button> */}
            <Button
              variant="outlined"
              sx={{
                borderRadius: "40px",
                fontSize: "14px",
                px: { xs: 2, md: 4 },
                color: "#848484",
                borderColor: "#848484",
              }}
            >
              Send results
            </Button>
            <Button
              variant="outlined"
              disabled={actionLoading === "invite"}
              endIcon={
                actionLoading === "invite" && (
                  <CircularProgress size={18} sx={{ color: "#848484" }} />
                )
              }
              sx={{
                borderRadius: "40px",
                fontSize: "14px",
                px: { xs: 2, md: 4 },
              }}
              onClick={() => onRequestAssesment(selectedRows)}
            >
              Request assessment
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="outlined"
              onClick={onReset}
              endIcon={
                actionLoading === "delete" && (
                  <CircularProgress size={18} sx={{ color: "#FF2D2D" }} />
                )
              }
              sx={{
                px: { xs: 2, md: 4 },
                py: 1.4,
                borderRadius: "7px",
                fontSize: '14px',
                color: "#848694",
                borderColor: "divider",
                fontStyle: "Outfit",
              }}
            >
              Reset Filters
            </Button>

            <CustomDatePicker
              start={filters?.startDate}
              end={filters?.endDate}
              onChange={onFilterChange}
            />
            <PassingCriteriaDialog value={filters} onChange={onFilterChange} />
            <FilterDropDown
              value={filters?.stage}
              data={resume_stages}
              placeholder="Stage"
              onChange={(newStage) => onFilterChange({ stage: newStage })}
            />
            <SearchInput
              value={searchText}
              onChange={_handleSearchTextChange}
              placeholder="Search"
              containerStyles={{ width: "100%", minWidth: "120px", flex: 0.4 }}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

/* Export
============================================================================= */
export default ResumeScreeningCandidatesTableHeader;
